import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Backdrop' })({
    backdrop: {
        zIndex: 4_000,
        background: 'rgba(255, 255, 255, 0.90)',
        backdropFilter: 'blur(7.5px)'
    }
});
